(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/assets/javascripts/views/pages/play-system-page.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/assets/javascripts/views/pages/play-system-page.js');

'use strict';

const {
  productMapping
} = svs.numbergames;
const {
  EUROJACKPOT_TUESDAY,
  EUROJACKPOT_FRIDAY
} = productMapping.CONSTANTS;
svs.eurojackpot.views.PlaySystemPage = Marionette.View.extend({
  viewOptions: ['showDrawCount', 'showAccountSelector'],
  showDrawCount: true,
  showAccountSelector: true,
  regions: {
    ngRowsContainerRegion: '#ngRowsContainerRegion',
    ngBetslipRegion: '#ngBetslipRegion',
    ngPayfooterRegion: '#ngPayfooterRegion'
  },
  behaviors: [{
    behaviorClass: svs.numbergames.game_app.behaviors.LoadModuleComponent,
    module: 'eurojackpot',
    component: 'play'
  }],
  template(data) {
    return svs.eurojackpot.templates.play_page(data);
  },
  initialize() {
    this.mergeOptions(this.options, this.viewOptions);
  },
  onRender() {
    if (svs.eurojackpot.components.play) {
      const isTargetB = svs.components.targeting.isTargeted('COT_Spelarvyn_ForvaldaDragningsdagar', 'B');
      const model = this.model || new svs.numbergames.game_model.models.Wager({
        productId: productMapping.CONSTANTS.EUROJACKPOT,
        selectedDays: isTargetB ? [svs.numbergames.game.draw.upcomingDrawProduct] : [EUROJACKPOT_TUESDAY, EUROJACKPOT_FRIDAY],
        isSystem: true
      }, {
        storageKey: 'system',
        parse: true,
        rules: svs.numbergames.rules.getRules({
          productId: svs.numbergames.productMapping.CONSTANTS.EUROJACKPOT
        }),
        hasTickets: svs.eurojackpot.data.hasTickets
      });
      if (!model.get('boards').length) {
        model.get('boards').activateNext();
      }
      this.showChildView('ngRowsContainerRegion', new svs.eurojackpot.components.play.views.SystemRowsContainer({
        model
      }));
      this.showChildView('ngBetslipRegion', new svs.eurojackpot.components.play.views.Betslip({
        model,
        showDrawCount: this.showDrawCount,
        showAccountSelector: this.showAccountSelector
      }));
      this.showChildView('ngPayfooterRegion', new svs.eurojackpot.components.play.views.Payfooter({
        model
      }));
    }
  }
});

 })(window);